"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svgs_1 = require("@@/assets/svgs");
const Button_1 = __importDefault(require("@mui/material/Button"));
function Test({ title, contents, noticeAction, }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'surface-table-row', css: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            columnGap: '4px',
            padding: '12px 14px',
            borderRadius: '8px',
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '4px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.WarningTriangleRedSvg, { css: { flexShrink: 0, width: '20px', height: '20px' } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle5 gray-80" }, { children: title }))] })), !!contents && contents] })), !!noticeAction && ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: noticeAction.actionFn, sx: {
                    flexShrink: 0,
                    height: '24px',
                    p: '0 12px',
                    borderRadius: '6px',
                    bgcolor: noticeAction.isBlueBtn
                        ? 'var(--blue-50) !important'
                        : 'var(--primary-main) !important',
                    color: 'var(--white)',
                } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: noticeAction.actionName })) })))] })));
}
exports.default = Test;
